export const IconWarning = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM8.22666 5.36601C8.4166 5.13432 8.70041 5 9 5H11C11.2996 5 11.5834 5.13432 11.7733 5.36601C11.9633 5.5977 12.0393 5.90234 11.9806 6.19612L10.9806 11.1961C10.8871 11.6635 10.4767 12 10 12C9.52332 12 9.1129 11.6635 9.01942 11.1961L8.01942 6.19612C7.96066 5.90234 8.03672 5.5977 8.22666 5.36601ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15Z"
                fill="currentColor"
            />
        </svg>
    );
};
